<template>
  <div v-if="post">
    <div
      v-if="userAnswer"
      class="block"
    >
      <router-link :to="`/user/drills/${userAnswer.drillId}`">
        <i class="fas fa-chevron-left"></i>
        <span>{{ $t('term.answers') }}</span>
      </router-link>
    </div>

    <h1 class="title">{{ $t('term.explanation') }}</h1>

    <div>
      <div>
        <h3 class="title is-5">{{ $t('term.question') }}</h3>

        <post-content
          :post="post"
          :is-disp-title="false"
        ></post-content>

        <div class="block mt-6">
          <h3 class="title is-5">{{ $t('term.yourAnswer') }}</h3>
          <div
            v-if="post.answerType === 'text'"
            class="block"
          >
            <div>
              <div v-if="userAnswerImageUrl">
                <figure class="image is-block">
                  <img :src="userAnswerImageUrl" />
                </figure>
              </div>
              <div v-if="userAnswerImageUrls">
                <ul>
                  <li
                    v-for="url in userAnswerImageUrls"
                    :key="url"
                    class="mb-4 relative"
                  >
                    <figure class="image is-block">
                      <img :src="url" />
                    </figure>
                    <button
                      class="delete absolute top-4 right-4"
                      @click="deleteUploadedFile(url)"
                    ></button>
                  </li>
                </ul>
              </div>

              <div>
                <FileInput
                  v-model="files"
                  :uploader-options="uploaderOptions"
                  :is-draggable="true"
                />
                <div v-if="thumbnails.length > 0">
                  <ul class="columns is-multiline is-tablet">
                    <li
                      v-for="(thumbnail, index) in thumbnails"
                      :key="index"
                      class="column is-half relative"
                    >
                      <button
                        class="delete absolute top-4 right-4"
                        @click="deleteFile(index)"
                      ></button>
                      <img
                        :src="thumbnail"
                        alt="Thumbnail"
                      />
                    </li>
                  </ul>
                  <div>
                    <button
                      @click="uploadFiles"
                      class="button is-info"
                    >
                      {{ $t('common.send') }}
                    </button>
                  </div>
                </div>
              </div>

              <div
                v-if="userAnswer.answer"
                class="pre-wrap"
              >
                {{ userAnswer.answer }}
              </div>
            </div>

            <div class="mt-20">
              <b-radio
                v-model="isCorrect"
                native-value="1"
                @input="updateCorrectState()"
              >
                <correct-status
                  :is-correct="true"
                  :is-bold="false"
                ></correct-status>
              </b-radio>
              <b-radio
                v-model="isCorrect"
                native-value="0"
                @input="updateCorrectState()"
                class="ml-3"
              >
                <correct-status
                  :is-correct="false"
                  :is-bold="false"
                ></correct-status>
              </b-radio>
            </div>
          </div>

          <div v-if="post.answerType === 'select'">
            <span class="has-text-weight-semibold">
              {{ answerLabels[userAnswerIndex] }}
            </span>
            <correct-status :is-correct="userAnswer.isCorrect"></correct-status>
          </div>
        </div>

        <div class="block mt-6">
          <h3 class="title is-5 is-clearfix mb-2">
            <span>{{ $t('common.comment') }}</span>
            <button
              v-if="isEditComment === false"
              @click="isEditComment = true"
              class="button is-ghost is-pulled-right"
            >
              {{ $t('common.edit') }}
            </button>
          </h3>

          <div v-if="isEditComment">
            <b-input
              v-model="comment"
              type="textarea"
            ></b-input>

            <div class="buttons mt-2">
              <button
                @click="saveComment()"
                class="button is-info"
              >
                {{ $t('common.save') }}
              </button>
              <button
                @click="isEditComment = false"
                class="button is-light"
              >
                {{ $t('common.cancel') }}
              </button>
            </div>
          </div>
          <div
            v-else
            class="block"
          >
            <div
              v-if="userAnswer.answerComment"
              class="pre-wrap"
            >
              {{ userAnswer.answerComment }}
            </div>
            <div v-else>{{ $t('common.unregistered') }}</div>
          </div>
        </div>
      </div>

      <div>
        <div class="block">
          <h3 class="title is-5">{{ $t('term.answer') }}</h3>
          <div
            v-if="post.answerType === 'text'"
            class="block"
          >
            {{ post.correctAnswerText }}
          </div>

          <select-type-answers-content
            v-if="post.answerType == 'select'"
            :answers="post.answersHtml"
            :correct-answer="post.correctAnswer"
          ></select-type-answers-content>
        </div>

        <div class="block mt-6">
          <h3 class="title is-5">{{ $t('form.answerExplanation') }}</h3>
          <html-content
            :body="post.answerExplanationHtml"
            class="mt-2"
          ></html-content>

          <ul v-if="'answerExpImages' in post && post.answerExpImages.length > 0">
            <li
              v-for="image in post.answerExpImages"
              :key="image.fileId"
              class="image"
            >
              <fb-img
                :fileId="image.fileId"
                :mimeType="image.mimeType"
                :media-service-id="post.serviceId"
                size="raw"
                class="mt-4"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- <nav
      v-if="post.category"
      class="breadcrumb"
      aria-label="breadcrumbs"
    >
      <ul>
        <li>
          <router-link :to="`/posts/${postServiceId}/`">{{ $t('common.posts') }}</router-link>
        </li>
        <li v-for="parent in post.category.parents">
          <router-link :to="`/posts/${postServiceId}/categories/${parent.slug}`">{{
            parent.label
          }}</router-link>
        </li>
        <li>
          <router-link :to="`/posts/${postServiceId}/categories/${post.category.slug}`">{{
            post.category.label
          }}</router-link>
        </li>
      </ul>
    </nav> -->

    <!-- <ul v-if="'tags' in post && post.tags">
      <li
        v-for="tag in post.tags"
        class="is-inline-block mr-2"
      >
        <router-link
          :to="`/posts/${postServiceId}/tags/${tag.label}`"
          class="tag"
          >{{ tag.label }}</router-link
        >
      </li>
    </ul> -->

    <UserEditMasterStatus
      :post-service-id="postServiceId"
      :post-id="postId"
    />
  </div>
</template>
<script>
import utilSite from '@/util/site'
import { Post, User } from '@/api'
import PostContent from '@/components/organisms/PostContent'
import HtmlContent from '@/components/atoms/HtmlContent'
import SelectTypeAnswersContent from '@/components/molecules/SelectTypeAnswersContent'
import FbImg from '@/components/atoms/FbImg'
import CorrectStatus from '@/components/atoms/CorrectStatus'
import Comments from '@/components/organisms/Comments'
import VoteUnit from '@/components/organisms/VoteUnit'
import UserEditMasterStatus from '@/components/organisms/UserEditMasterStatus'
import FileInput from '@/components/molecules/FileInput'

export default {
  name: 'UserAnswer',

  components: {
    PostContent,
    HtmlContent,
    FbImg,
    CorrectStatus,
    Comments,
    VoteUnit,
    SelectTypeAnswersContent,
    UserEditMasterStatus,
    FileInput,
  },

  data() {
    return {
      userAnswer: null,
      post: null,
      answerLabels: ['A', 'B', 'C', 'D'],
      isCorrect: null,
      comment: '',
      isEditComment: false,
      files: [],
      thumbnails: [],
      uploaderOptions: null,
      userAnswers: [],
    }
  },

  computed: {
    answerId() {
      return this.$route.params.answerId
    },

    postId() {
      return this.userAnswer.postId
    },

    isExecutingAnswer() {
      return this.$store.getters.isExecutingAnswer()
    },

    userAnswerId() {
      if (this.userAnswer == null) return ''
      return this.userAnswer.userAnswerId
    },

    userAnswerIndex() {
      if (this.userAnswer == null) return null
      if (this.post.answerType !== 'select') return null
      if (this.userAnswer.answer === null) return null
      return Number(this.userAnswer.answer)
    },

    userAnswerImageUrl() {
      if (this.userAnswer == null) return ''
      if (!this.userAnswer.answerImagePath) return ''
      return utilSite.storageUri(this.userAnswer.answerImagePath)
    },

    userAnswerImageUrls() {
      if (this.userAnswer == null) return []
      if (!this.userAnswer.answerImagePaths) return []
      const res = []
      for (const path of this.userAnswer.answerImagePaths) {
        res.push(utilSite.storageUri(path))
      }
      return res
    },

    postServiceId() {
      return this.post.serviceId
    },

    // fixThreshold() {
    //   if (this.$refs.fixTarget == null) return 0
    //   return this.$refs.fixTarget.offsetTop
    // },

    // fixTargetHeight() {
    //   return this.$refs.fixTarget.clientHeight
    // },

    // fixTargetParentPadding() {
    //   if (this.isFixed === false) return 0
    //   const canvasSize = window.innerHeight / 2
    //   return this.fixTargetHeight < canvasSize ? `${this.fixTargetHeight}px` : `${canvasSize}px`
    // },
  },

  watch: {
    files(vals) {
      if (vals.length === 0) return

      vals.map((file) => {
        if (file && file.type.startsWith('image/')) {
          const reader = new FileReader()
          reader.onload = (e) => {
            this.thumbnails.push(e.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          this.imageSrc = null
        }
      })
    },
  },

  async created() {
    this.setUploaderOptions()
    await this.init()
  },

  mounted() {
    // window.addEventListener('scroll', this.handleFixed)
  },

  destroyed() {},

  methods: {
    async init() {
      await this.setAnswer()
      await this.setPost()
      if (this.userAnswer.isCorrect != null) {
        this.isCorrect = this.userAnswer.isCorrect === true ? '1' : '0'
      }
      this.comment = this.userAnswer.answerComment
    },

    setUploaderOptions() {
      this.uploaderOptions = {
        sizes: '1200x1200,800x800,400x400,400x400xs',
        mimeTypes: 'image/png,image/gif,image/jpeg',
        extensions: ['png', 'gif', 'jpg', 'jpeg'],
        sizeLimitMB: 5,
      }
    },

    async setAnswer(answerId) {
      this.$store.dispatch('setLoading', true)
      try {
        this.userAnswer = await User.getAnswer(this.answerId, null, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setPost() {
      this.$store.dispatch('setLoading', true)
      try {
        this.post = await Post.getDetailById(this.postId)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async updateCorrectState() {
      const vals = { isCorrect: this.isCorrect }
      await this.updateAnswer(vals)
    },

    async saveComment() {
      const vals = { comment: this.comment }
      await this.updateAnswer(vals)
      this.isEditComment = false
    },

    async updateAnswer(vals) {
      this.$store.dispatch('setLoading', true)
      try {
        this.userAnswer = await User.updateAnswer(this.answerId, vals, this.userToken)
        this.$store.dispatch('setLoading', false)
        this.showGlobalMessage(this.$t('msg.Updated'), 'is-success')
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Values not updated"]'))
      }
    },

    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => resolve(e.target.result)
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file)
      })
    },

    async uploadFiles() {
      try {
        this.$store.dispatch('setLoading', true)
        await this.forceRefreshToken()

        let base64Files = []
        if (this.files.length > 0) {
          base64Files = await Promise.all(this.files.map((file) => this.convertToBase64(file)))
        }
        const params = {
          files: base64Files,
        }
        const res = await User.uploadDrillAnswerFiles(
          this.userAnswer.drillId,
          this.userAnswerId,
          params,
          this.userToken
        )
        this.userAnswer = res
        this.files = []
        this.thumbnails = []
      } catch (err) {
        console.log(err) //!!!!!!
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    deleteFile(index) {
      this.files.splice(index, 1)
    },

    async deleteUploadedFile(imagePath) {
      const regex = /([0-9a-zA-Z]{26}\.(jpg|jpeg|png|gif))$/
      const match = imagePath.match(regex)
      if (!match) {
        this.showGlobalMessage('fileId not found', 'is-danger')
        return
      }
      const fileName = match[1]
      try {
        this.$store.dispatch('setLoading', true)
        await this.forceRefreshToken()
        const res = await User.deleteAnswerImage(this.userAnswerId, fileName, this.userToken)
        this.userAnswer = res
      } catch (err) {
        console.log(err) //!!!!!!
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // handleFixed() {
    //   const scrollY = window.scrollY
    //   if (scrollY >= this.fixThreshold + 50) {
    //     this.isFixed = true
    //   } else {
    //     this.isFixed = false
    //   }
    // },
  },
}
</script>
<style>
/*
.h-1000px {
  height: 1000px;
}
.overflow-scroll {
  overflow: scroll;
}
*/
/*
.fixed {
  padding: 20px 1.5rem;
  position: fixed;
  top: 0;
  background-color: #fff;
  z-index: 9000;
  width: calc(100% - 3rem);
  height: 50%;
  overflow: scroll;
}

.fix-target.fixed {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  border-bottom: 1px solid #ddd;
}

.fix-target img {
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  height: auto;
}
*/
</style>
